import React from 'react';
import { inputClass } from './adminFormStyles';

const EMPTY_TIER = { id: '', name: '', description: '', price: '', maxQuantity: '' };

const COLUMNS = [
  { key: 'name', label: 'Package name', type: 'text', required: true },
  { key: 'description', label: 'Description', type: 'text', required: false },
  { key: 'price', label: 'Price (KES)', type: 'number', required: true, placeholder: '0', min: 0 },
  { key: 'maxQuantity', label: 'Max qty', type: 'number', required: false, placeholder: 'Optional', min: 1 }
];

const PricingTierEditor = ({ tiers, onChange, emptyTier = EMPTY_TIER }) => {
  const updateTier = (index, key, value) => {
    const next = [...tiers];
    next[index] = { ...next[index], [key]: value };
    onChange(next);
  };

  return (
    <div className="rounded-lg border border-orange-200 bg-orange-50/30 overflow-hidden">
      <div className="px-3 py-2.5 bg-white/90 border-b border-orange-100 text-xs text-gray-600 space-y-1">
        <p>
          <span className="font-medium text-gray-700">Package name:</span>{' '}
          e.g. Adult, VIP, Early Bird, Group of 5, Kids
        </p>
        <p>
          <span className="font-medium text-gray-700">Description:</span>{' '}
          e.g. Standard entry for one adult, includes welcome drink
        </p>
      </div>
      <div className="hidden md:grid md:grid-cols-4 gap-2 px-3 py-2 bg-orange-100/60 border-b border-orange-200">
        {COLUMNS.map((col) => (
          <span key={col.key} className="text-[11px] font-semibold uppercase tracking-wide text-orange-900/80">
            {col.label}
            {col.required && <span className="text-orange-600 ml-0.5">*</span>}
          </span>
        ))}
      </div>

      <div className="divide-y divide-orange-100/80">
        {tiers.map((tier, index) => (
          <div key={tier.id || index} className="p-2 md:p-3 bg-white/80">
            <p className="md:hidden text-[11px] font-semibold text-gray-500 mb-2">Package {index + 1}</p>
            <div className="grid grid-cols-1 md:grid-cols-4 gap-2">
              {COLUMNS.map((col) => (
                <div key={col.key}>
                  <label className="md:sr-only text-[11px] font-medium text-gray-500 mb-0.5 block">
                    {col.label}
                  </label>
                  <input
                    type={col.type}
                    min={col.min}
                    step={col.type === 'number' ? '1' : undefined}
                    placeholder={col.placeholder}
                    value={tier[col.key] ?? ''}
                    onChange={(e) => updateTier(index, col.key, e.target.value)}
                    className={inputClass}
                  />
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      <div className="flex items-center gap-3 px-3 py-2 bg-orange-50/50 border-t border-orange-200">
        <button
          type="button"
          onClick={() => onChange([...tiers, { ...emptyTier }])}
          className="text-xs font-semibold text-orange-700 hover:text-orange-800"
        >
          + Add package
        </button>
        {tiers.length > 1 && (
          <button
            type="button"
            onClick={() => onChange(tiers.slice(0, -1))}
            className="text-xs font-medium text-gray-500 hover:text-gray-700"
          >
            Remove last
          </button>
        )}
      </div>
    </div>
  );
};

export default PricingTierEditor;
